module.exports = "<div id=\"portfolioContainer\">\n\t<app-portfolio-nav></app-portfolio-nav>\n\t<router-outlet></router-outlet>\n</div>\n"